module.exports = __webpack_public_path__ + "startpage-746fed5a/carlos-barquero-ac3080e4f7a95a6930e971192475e8d2.jpg";